import { useSelector } from "react-redux";
import { type RootState } from "features/Application/globaltypes/redux";
import dateTimeUtils, { type MomentInput } from "../utils/dateTimeUtils";
import moment from "moment";

/**
 * Hook that returns a timezone-aware date formatting function
 * @returns Function that formats date/time for reporting, handling both combined datetime strings and separate date/time values
 */
export const useReportingFormatWithTimeZone = () => {
  const timeZone = useSelector((state: RootState) => state.userProfile.timeZone) || "UTC";

  return (date: MomentInput) => {
    let utcTimestamp: moment.Moment;

    utcTimestamp = moment.utc(date);

    if (!utcTimestamp.isValid()) {
      return "-";
    }
    return dateTimeUtils.reportingFormatWithTimeZone(utcTimestamp, timeZone);
  };
};
